import React, { useEffect, useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/gobizTableStyle';
import { makeStyles, useTheme } from '@material-ui/core';
import { translate } from 'components/Translation';
import ServicePicker from 'components/ServicePicker';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import SimpleColumn from './columns/SimpleColumn';
import { planCells, topUpCells } from './constants';
import CustomColumn from './columns/CustomColumn';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IGobizTableProps {
	catalogEntryView: types.ecommerce.CatalogEntryView[];
	activeCatalogEntryView: types.ecommerce.CatalogEntryView | undefined;
	selectedTab: number | null;
	setSelectedTab: React.Dispatch<React.SetStateAction<number | null>>;
	type: types.services.tableType;
}

const GobizTable = ({
	catalogEntryView,
	activeCatalogEntryView,
	selectedTab,
	setSelectedTab,
	type,
}: IGobizTableProps) => {
	const classes = useStyles();
	const theme = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));

	const maxValue = useMemo(() => {
		let _maxValue = 0;
		catalogEntryView.forEach((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			const packageSize = extractAttributeValue({ attributes }, CustomAttribute.MBB_PACKAGE_SIZE);
			const mbbPackageSize = packageSize?.endsWith('MB')
				? parseInt(packageSize) / 1000
				: parseInt(packageSize) || 0;
			const mbbPackageSizeGobiz =
				parseInt(extractAttributeValue({ attributes }, CustomAttribute.MBB_PACKAGE_SIZE_GOBIZ)) || 0;
			_maxValue = Math.max(_maxValue, mbbPackageSize, mbbPackageSizeGobiz);
		});
		return _maxValue;
	}, [catalogEntryView]);

	const tabs = useMemo(() => {
		return catalogEntryView.map((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			const useItemDesc = extractAttributeValue({ attributes }, CustomAttribute.USE_ITEM_DESC);
			const cells = type === 'TOP_UP' ? topUpCells : planCells;
			return {
				column: useItemDesc ? (
					<CustomColumn uniqueId={singleCatalogEntryView.uniqueID} prices={singleCatalogEntryView.price} />
				) : (
					<SimpleColumn maxValue={maxValue} catalogEntryView={singleCatalogEntryView} cells={cells} />
				),
				numberOfCells: cells.length + 1,
				header: {
					title: singleCatalogEntryView.name,
					superscription: translate('number.services.gobiz'),
				},
			};
		});
	}, [catalogEntryView, maxValue, type]);

	useEffect(() => {
		if (activeCatalogEntryView) {
			const index = catalogEntryView.findIndex(
				(singleCatalogEntryView) => singleCatalogEntryView.partNumber === activeCatalogEntryView.partNumber
			);
			setSelectedTab(index);
		}
	}, [activeCatalogEntryView, catalogEntryView, setSelectedTab]);

	return (
		<div className={classes.gobizTableWrapper}>
			<ServicePicker
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
				tabs={tabs}
				numberOfTabsOnSlide={xsDown ? 1 : tabs.length}
				selectedTabColor="primary"
			/>
		</div>
	);
};

export default GobizTable;
